import type { LinkType, MenuType } from 'types'
import { Props as EmailOfTheDayProps } from '../EmailOfTheDay'

import { useMediaQuery } from '../MediaQuery'
import FooterDesktop from './FooterDesktop'
import FooterMobile from './FooterMobile'

type MainLinks = LinkType & { below: MenuType[] }

export type Props = {
  className?: string
  copyrightText: string
  emailOfTheDay: EmailOfTheDayProps
  findABoxLink: LinkType
  legalLabelText: string
  legalLinks: LinkType[]
  mainLinks: MainLinks[]
  belowTablet?: boolean
}

function Footer(props: Props) {
  const { belowMobile, belowTablet } = useMediaQuery({
    mobile: true,
    tablet: true,
  })

  return belowMobile ? (
    <FooterMobile {...props} />
  ) : (
    <FooterDesktop {...props} belowTablet={belowTablet} />
  )
}

export default Footer
